/**
 * Mensajes de login — mantener alineados con login-security-messages.js (API Portal) y
 * apps/shell/src/services/Auth/loginSecurityMessages.js (tenant WMS).
 */
export const LOGIN_INVALID_CREDENTIALS = 'Credenciales inválidas.';
export const LOGIN_ACCOUNT_LOCKED = 'Cuenta temporalmente bloqueada. Probá más tarde.';
export const LOGIN_BIOMETRIC_FAILED =
  'No se pudo verificar tu acceso biométrico. Ingresá con usuario y contraseña.';
export const LOGIN_RATE_LIMITED = 'Demasiados intentos. Probá más tarde.';
export const LOGIN_AMBIGUOUS_CLIENT = 'Elegí el entorno WMS al que querés ingresar.';
export const LOGIN_FIELDS_REQUIRED = 'Por favor completá todos los campos.';
/** Fallback sin mail: el contacto de soporte solo lo agrega la API en prod. */
export const LOGIN_AD_PASSWORD_EXPIRED =
  'Tu contraseña de Active Directory está vencida o debe cambiarse; hasta restablecerla no vas a poder ingresar.';

/** Mapeo defensivo de errores HTTP de login (no filtrar upstream). */
export function mapPortalLoginError(err, fallback = LOGIN_INVALID_CREDENTIALS) {
  const status = err?.status ?? err?.statusCode;
  const code = err?.payload?.code ?? err?.code;
  if (status === 423 || code === 'ACCOUNT_LOCKED') return LOGIN_ACCOUNT_LOCKED;
  if (
    status === 429 ||
    code === 'RATE_LIMITED' ||
    code === 'AUTH_RATE_LIMITED'
  ) {
    return LOGIN_RATE_LIMITED;
  }
  if (status === 409 && code === 'PORTAL_CLIENT_AMBIGUOUS') {
    return LOGIN_AMBIGUOUS_CLIENT;
  }
  if (code === 'AUTH_AD_PASSWORD_EXPIRED') {
    const fromApi = String(err?.payload?.message || err?.message || '').trim();
    if (fromApi) return fromApi;
    return LOGIN_AD_PASSWORD_EXPIRED;
  }
  if (
    status === 401
    || code === 'LOGIN_FAILED'
    || code === 'PORTAL_BIOMETRIC_VERIFY_FAILED'
    || code === 'AUTH_BIOMETRIC_VERIFY_LOGIN_FAILED'
    || code === 'AUTH_BIOMETRIC_LOGIN_OPTIONS_FAILED'
  ) {
    return fallback;
  }
  return fallback;
}
